<template>
  <div class="category-block">
    
    <div id="commentsList" class="comments-list" ref="commentsList">
      <div v-if="loading" class="empty-comments" style="color: #999; text-align: center; padding: 20px;">Loading comments...</div>
      <div v-else-if="comments.length === 0" class="empty-comments" style="color:#999; text-align:center; padding:20px;">Review the design and leave your thoughts below.</div>
      <div v-else>
        <div v-for="comment in comments" :key="comment.id" class="comment-item">
          <div class="comment-header">
            <div class="comment-user-info">
              <span class="comment-user">{{ comment.user_name || 'Anonymous' }}</span>
              <span v-if="comment.garment_type" class="comment-garment">{{ getGarmentDisplayName(comment.garment_type) }}</span>
            </div>
            <span class="comment-time">{{ formatTime(comment.created_at) }}</span>
          </div>
          <div class="comment-text">{{ comment.comment_text }}</div>
        </div>
      </div>
    </div>
    <div class="comment-input-area">
      <textarea v-model="commentText" rows="2" placeholder="Add feedback / comments for the design..." class="comment-textarea"></textarea>
      <div class="comment-row">
        <input type="text" v-model="userName" placeholder="Enter your name" class="comment-name-input">
        <button @click="postComment" :disabled="isPosting" class="post-comment-btn">
          {{ isPosting ? 'Posting...' : 'Post Comment' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// ... 脚本部分保持不变 ...
import { mapState, mapActions } from 'pinia'
import { useDesignStore } from '@/stores/designStore'

export default {
  name: 'Comments',
  data() {
    return {
      comments: [],
      loading: false,
      userName: '',
      commentText: '',
      isPosting: false,
      garmentDisplayNames: {
        'Short Sleeve': 'Short sleeve jersey',
        'Long Sleeve': 'Long sleeve jersey',
        'Cycling Vest': 'Cycling vest',
        'Mx Jersey': 'MX jersey',
        'Hoodie': 'Hoodie',
        'T-shirt': 'T-shirt',
        'Baseball Jersey': 'Baseball jersey'
      }
    }
  },
  computed: {
    ...mapState(useDesignStore, ['currentGarment', 'currentDesignId'])
  },
  mounted() {
    this.loadComments()
    this.$watch(
      () => useDesignStore().currentDesignId,
      (newId) => {
        if (newId) {
          this.loadComments()
        }
      },
      { immediate: true }
    )
  },
  methods: {
    ...mapActions(useDesignStore, ['saveCurrentGarmentData', 'exportAllGarmentsData']),
    
    updateUrlWithDesignId(id) {
      if (!id) return
      const url = new URL(window.location.href)
      if (url.searchParams.get('id') !== id) {
        url.searchParams.set('id', id)
        window.history.replaceState({}, '', url.toString())
      }
    },
    
    async ensureDesignId() {
      const store = useDesignStore()
      if (store.currentDesignId) return store.currentDesignId

      this.saveCurrentGarmentData()
      const allGarmentsData = this.collectAllGarmentsData()
      
      const designData = {
        email: null,
        current_garment: this.currentGarment || 'Short Sleeve',
        all_garments: allGarmentsData
      }
      
      if (store.currentDesignId) {
        designData.design_id = store.currentDesignId
      }
      
      try {
        const response = await fetch('/save-design.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(designData)
        })
        const result = await response.json()
        if (!result.success) throw new Error(result.message || 'Save failed')
        
        const newId = result.design_id
        if (!store.currentDesignId || store.currentDesignId !== newId) {
          store.currentDesignId = newId
          this.updateUrlWithDesignId(newId)
        }
        return store.currentDesignId
      } catch (error) {
        console.error('Silent save error:', error)
        throw error
      }
    },

    async saveCurrentDesign(email = null, sendEmail = false) {
      this.saveCurrentGarmentData()
      const allGarmentsData = this.collectAllGarmentsData()
      
      const designData = {
        email: email || 'anonymous@example.com',
        current_garment: this.currentGarment || 'Short Sleeve',
        all_garments: allGarmentsData
      }
      
      const store = useDesignStore()
      if (store.currentDesignId) {
        designData.design_id = store.currentDesignId
      }
      
      try {
        const response = await fetch('/save-design.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(designData)
        })
        const result = await response.json()
        if (!result.success) throw new Error(result.message || 'Save failed')
        
        const newId = result.design_id
        if (!store.currentDesignId || store.currentDesignId !== newId) {
          store.currentDesignId = newId
          this.updateUrlWithDesignId(newId)
        }
        
        const designLink = `https://customteamkit.com/index.html?id=${store.currentDesignId}`
        let emailSent = false
        if (sendEmail && email) {
          try {
            const emailRes = await fetch('/send-email.php', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email, design_link: designLink })
            })
            const emailResult = await emailRes.json()
            emailSent = emailResult.success === true
          } catch (e) {
            console.error('Email send error:', e)
          }
        }
        return { success: true, designId: store.currentDesignId, link: designLink, emailSent }
      } catch (error) {
        console.error('Save error:', error)
        return { success: false, error: error.message, emailSent: false }
      }
    },
    
    collectAllGarmentsData() {
      const store = useDesignStore()
      return store.exportAllGarmentsData().all_garments
    },
    
    async loadComments() {
      const store = useDesignStore()
      const targetDesignId = store.currentDesignId
      if (!targetDesignId) {
        this.comments = []
        this.loading = false
        return
      }
      this.loading = true
      try {
        const response = await fetch(`/get-comments.php?design_id=${targetDesignId}`)
        const result = await response.json()
        if (result.success && result.comments) {
          this.comments = result.comments
        } else {
          this.comments = []
        }
      } catch (error) {
        console.error('Load comments error:', error)
        this.comments = []
      } finally {
        this.loading = false
      }
    },
    
    async postComment() {
      const commentText = this.commentText.trim()
      if (!commentText) {
        alert('Please enter a comment.')
        return
      }
      if (commentText.length > 500) {
        alert('Comment is too long. Maximum 500 characters.')
        return
      }
      
      const userName = this.userName.trim() || 'Anonymous'
      if (userName.length > 50) {
        alert('Name is too long. Maximum 50 characters.')
        return
      }
      
      if (this.isPosting) return
      this.isPosting = true
      
      const store = useDesignStore()
      let designId = store.currentDesignId
      
      if (!designId) {
        await this.ensureDesignId()
        designId = store.currentDesignId
      }
      
      const currentGarment = store.currentGarment
      
      try {
        const response = await fetch('/add-comment.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            design_id: designId,
            garment_type: currentGarment,
            user_name: userName,
            comment_text: commentText
          })
        })
        const result = await response.json()
        if (result.success) {
          this.commentText = ''
          await this.loadComments()
        } else {
          alert('Failed to post comment: ' + (result.message || 'Unknown error'))
        }
      } catch (error) {
        console.error('Post comment error:', error)
        alert('Network error, please try again.')
      } finally {
        this.isPosting = false
      }
    },
    
    getGarmentDisplayName(garmentType) {
      return this.garmentDisplayNames[garmentType] || garmentType
    },
    
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const now = new Date()
      const diff = Math.floor((now - date) / 1000)
      if (diff < 60) return 'just now'
      if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
      if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
      return `${Math.floor(diff / 86400)}d ago`
    }
  }
}
</script>

<style scoped>
.comments-list {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 10px;
  /* 移除 background: #ffffff */
  border-radius: 8px;
  padding: 0;  /* 移除内边距，让子元素的 padding 生效 */
}
.comment-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 8px;
  border-left: 3px solid #3b82f6;
}
.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  flex-wrap: wrap;
  gap: 4px;
}
.comment-user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.comment-user {
  font-weight: bold;
  color: #3b82f6;
  font-size: 0.75rem;
}
.comment-garment {
  background: #e0e7ff;
  color: #3730a3;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 0.65rem;
  font-weight: 500;
}
.comment-time {
  font-size: 0.6rem;
  color: #999;
}
.comment-text {
  font-size: 0.8rem;
  color: #333;
  word-wrap: break-word;
}
.comment-input-area {
  /* 移除 background: #ffffff */
  border-radius: 8px;
  padding: 10px 0 0 0;  /* 只保留上下内边距，左右无 */
}
.comment-row {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 2px;
}
.comment-name-input {
  flex: 2;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.85rem;
  background-color: #f8fff5;
}
.post-comment-btn {
  background: #10b981;
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: background 0.2s;
  white-space: nowrap;
}
.post-comment-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.comment-textarea {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 0.85rem;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
  background-color: #f7fbf2;
  margin-bottom: 8px;
}
.empty-comments {
  background-color: #f7fbf2;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 20px;
  text-align: center;
  color: #999;
}
.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #072a47;
  margin-bottom: 0.3rem;
  padding-left: 4px;
}
.category-block {
  margin-bottom: 0.6rem;
}

@media (max-width: 850px) {
  .comment-row {
    flex-direction: column;
    align-items: stretch;
  }
  .comment-name-input {
    width: 100%;
  }
  .post-comment-btn {
    width: 100%;
  }
}
</style>